import { useState, type FormEvent } from 'react';
import { Arrow } from './Button';

export interface AskBarProps {
  placeholder?: string;
  hint?: string;
  disabled?: boolean;
  onSubmit?: (question: string) => void;
  autoFocus?: boolean;
}

/** "pergunte, procure, investigue..." */
export function AskBar({
  placeholder = 'pergunte, procure, investigue...',
  hint,
  disabled,
  onSubmit,
  autoFocus,
}: AskBarProps) {
  const [value, setValue] = useState('');
  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = value.trim();
    if (!q || disabled) return;
    onSubmit?.(q);
  };
  return (
    <form onSubmit={submit}>
      <div className="rr-ask">
        <input
          className="rr-ask__input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          aria-label="Pergunte à Machine"
        />
        <button className="rr-ask__submit" type="submit" aria-label="Enviar" disabled={disabled}>
          <Arrow />
        </button>
      </div>
      {hint && <p className="rr-ask__hint">{hint}</p>}
    </form>
  );
}
